import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="submit-now"
export default class extends Controller {
    initialize() {
        this.submit = this.submit.bind(this)
    }

    connect() {
        this.submit()
    }

    submit() {
        this.element.requestSubmit()
    }
}
